import * as apiGet from 'api/nutrient/GetNutrientIdV1';

export default class NutrientCategory {
	public id: string = '';
	public name: string = '';

	public constructor(input?: apiGet.NutrientCategory) {
		if (input) {
			this.mapFromApi(input);
		}
	}

	public mapFromApi(input: apiGet.NutrientCategory): void {
		this.id = input.id;
		this.name = input.name;
	}
}
